import React, {memo} from 'react';
import {Handle, Position} from 'reactflow';

import {Box, List, ListItem, Stack, Tooltip, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {CornerDownRightIcon, FormIcon} from "@hugeicons/core-free-icons";
import {NodeType} from "../model/ModelData";
import {
  getPalette,
  hexToRgba,
  iconChipSx,
  nodeHeaderSx,
  nodeKickerSx,
  nodeShellSx,
  nodeSurfaceSx,
  nodeTitleSx,
  sectionSx,
} from "./nodeTheme";

function FormNode({id, data, selected}) {
  const {steps, name, isConnected, node} = data;
  const hasSteps = steps?.length > 0;
  const palette = getPalette(isConnected ? "form" : "warning");

  return (
    <Tooltip title={!isConnected ? "Please connect node with other node" : name}>
      <Box className={`node custom-node ${node?.data?.use_llm ? "magic-node" : ""}`}
           sx={{minWidth: "216px", maxWidth: "216px", ...nodeShellSx(palette, {selected})}}
      >
        {/* target dot – up top, level with the node icon */}
        <Handle type="target" position={Position.Left} id={id} style={{top: 16}}/>
        <Box sx={nodeSurfaceSx}>
          <Box sx={{...nodeHeaderSx(palette), ...sectionSx({first: true, last: !hasSteps})}}>
            <Box sx={iconChipSx(palette)}>
              <HugeiconsIcon icon={FormIcon} size={12} strokeWidth={1.8}/>
            </Box>
            <Box sx={{minWidth: 0, flex: 1}}>
              <Typography component="span" sx={nodeKickerSx(palette)}>form</Typography>
              <Typography noWrap sx={nodeTitleSx()}>{name}</Typography>
            </Box>
          </Box>
          {hasSteps && (
            <Box className="custom-node__body" sx={{bgcolor: "#FFFFFF", ...sectionSx({last: true})}}>
              <List sx={{p: 0, m: 0}}>
                {
                  steps.map((step, index) => {
                    const isLast = index === steps.length - 1;
                    return <ListItem
                      key={step?.id || index}
                      sx={{
                        position: "relative",
                        background: "transparent",
                        borderBottom: isLast ? 0 : `1px solid ${palette.border}`,
                        py: 0.6, px: 1,
                        transition: "background .15s ease",
                        "&:hover": {background: hexToRgba(palette.accent, 0.06)},
                        ...(isLast && sectionSx({last: true})),
                      }}>
                      <Stack direction={"row"} gap={0.75} alignItems={"center"} sx={{width: "100%"}}>
                        <Box sx={{display: "flex", color: palette.accent}}>
                          {step?.icon || <HugeiconsIcon icon={CornerDownRightIcon} size={12}/>}
                        </Box>
                        <Typography noWrap sx={{fontSize: 9, fontWeight: 400, flex: 1, color: "#475569"}}>
                          {step?.text}
                        </Typography>
                      </Stack>
                      {
                        step?.type && step?.type === NodeType.END_FORM &&
                        <Handle type="source" position={Position.Right} id={step?.id}/>
                      }
                    </ListItem>
                  })
                }
              </List>
            </Box>
          )}
        </Box>
      </Box>
    </Tooltip>
  )
}

export default memo(FormNode);
